export default {
  // 页面标题
  黑名单列表: "黑名单列表",
  添加黑名单: "添加黑名单",
  供应商黑名单: "供应商黑名单",

  // 表单字段
  移入黑名单原因: "移入黑名单原因",
  移出黑名单原因: "移出黑名单原因",
  请输入移入黑名单原因: "请输入移入黑名单原因",
  请输入移出黑名单原因: "请输入移出黑名单原因",
  请输入: "请输入",

  // 表格列
  供应商名称: "供应商名称",
  供应商名称中文: "供应商名称（中文）",
  供应商名称英文: "供应商名称（英文）",

  // 操作按钮
  申请移出黑名单: "申请移出黑名单",

  // 成功提示
  删除成功: "删除成功",
  移入申请已提交: "移入申请已提交",
  移出申请已提交: "移出申请已提交",
};
